import React from 'react';
import { styled } from '@compiled/react';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import messages from './messages';
import type { Props } from './types';

const RecalculationWarningView = ({ data, loading, error, intl: { formatMessage } }: Props) => {
	if (loading || error || !data || data.shouldWarn === false) {
		return null;
	}

	return (
		<Spaced>
			<SectionMessage appearance="warning" title={formatMessage(messages.reCalculationCostTitle)}>
				{/* eslint-disable-next-line @atlaskit/design-system/use-primitives-text */}
				<p>
					{formatMessage(messages.reCalculationCostWarningMessageJsm, {
						issueCount: data.requestCount,
					})}
				</p>
			</SectionMessage>
		</Spaced>
	);
};

export const RecalculationWarning = injectIntl(RecalculationWarningView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Spaced = styled.div({
	margin: `${token('space.100', '8px')} 0 ${token('space.100', '8px')} 0`,
});
